import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPut } from './client';
import type { NotificationCategory, NotificationChannel } from './notifications';

export interface PreferenceDto {
  userId: string;
  orgId: string;
  category: NotificationCategory;
  channel: NotificationChannel;
  optedOut: boolean;
  updatedAt: string;
}

export interface SetPreferencesInput {
  orgId: string;
  preferences: Array<{
    category: NotificationCategory;
    channel: NotificationChannel;
    optedOut: boolean;
  }>;
}

export function useNotificationPreferences(userId: string) {
  return useQuery({
    queryKey: ['notification-preferences', userId],
    queryFn: () => apiGet<PreferenceDto[]>(`/api/notifications/preferences/${userId}`),
    enabled: !!userId,
  });
}

export function useSetNotificationPreferences(userId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: SetPreferencesInput) =>
      apiPut<void>(`/api/notifications/preferences/${userId}`, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notification-preferences', userId] }),
  });
}
